const setData = function (state, data) {
    state.data = data
}

const setCatalogStoryData = function (state, story) {
    state.data = {
        ...state.data,
        story,
    }
}

export default {
    setData,
    setCatalogStoryData,
}
